// import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Component } from '@angular/core';
import { Store } from '@src/store';
import moment from 'moment';
import { reportsActions } from '@src/store/reducers/reportsReducer';

@Component({
    selector: 'deployed-details-packages',
    template: require('./deployed-details-packages.component.html'),
    styles: [require('./deployed-details-packages.component.scss')]
})
export class DeployedPackagesDetailsComponent {
  public criteria: any
  public flagpaging = true;
  public Criteria:any = {};
  public tableData:any = []
  public resetSize:boolean = false;
  

  
  public sortFlag :boolean = false;

constructor(private store: Store){
}

public filter(criteria) {
    this.criteria = criteria;
    this.getRecords();
}

public flagpag(flag:boolean){
  this.flagpaging = flag;
}

public getRecords (page = 1) {
    this.resetSize = false
    if(this.criteria.data.project == null){
        this.tableData = [];
    }
    else {
        let fromDate = moment(this.criteria.data.fromDate);
        let toDate = moment(this.criteria.data.toDate);
        if (this.criteria.data.fromDate) {
            fromDate.startOf('day')
        }
        if (this.criteria.data.toDate) {
            toDate.endOf('day');
        }
        let sortingWay = [{ColumnName: "package_name", IsAscending: false}]
        if(this.criteria.data.manualSorting){
            sortingWay =  [{ColumnName: this.criteria.data.manualSorting.colName , IsAscending: this.criteria.data.manualSorting.isAscending}]
        }
        if(this.criteria.data.fromFilter){
            page = 1;
            this.resetSize = true
        }

        const payload = {
            "Filters": [
                this.getFilter("ProjectIds", ((Array.isArray(this.criteria.data.project?.id) && this.criteria.data.project?.id.length) || !Array.isArray(this.criteria.data.project.id)) ? this.criteria.data.project.id.toString(): null),
                this.getFilter("AppUser", (this.criteria.data.user !== undefined) && (this.criteria.data.user?.length !== 0) ? this.criteria.data.user.toString(): null),
                this.getFilter("TagValue", (this.criteria.data.tag !== undefined) && (this.criteria.data.tag?.length !== 0) ? this.criteria.data.tag.toString() : null),
                this.getFilter("PackageName", (this.criteria.data.package !== undefined) && (this.criteria.data.package?.length !== 0) ? this.criteria.data.package.toString() : null),
                this.getFilter("FromDate", (this.criteria.data.fromDate) ? fromDate.toDate() : null),
                this.getFilter("ToDate", this.criteria.data.toDate ? toDate.toDate() : null),
                                                                       
            ]
    
           , Page: page,
             Count: 15,
             Sorting: sortingWay
        };
        // if(this.criteria.data.fromFilter || this.criteria.data.manualSorting && !this.flagpaging){   
        //     payload.Page=1;
        // }
        let type = reportsActions.GET_DEPLOYED_PACKAGES;
        this.store.dispatch({ type,  data: payload}).then((res) => {
            if (res && res.length == 0 && this.criteria.data.fromFilter){
                this.tableData = res
            }
            if(this.criteria.data.fromFilter){
                this.tableData = [];
            }
            if(res && res.length > 0 && (this.criteria.data.fromFilter || this.criteria.data.manualSorting) && !this.flagpaging ){
                this.tableData = [];
            }
            if (res && res.length > 0) {
                if(this.flagpaging){
                    this.tableData = [...this.tableData, ...res]
                    this.flagpaging = false
                }
                else { 
                    this.tableData = res
                    page = 1;
                }
                this.Criteria = this.criteria; 
                this.criteria.data.fromFilter = false;
            }   
        });
    }
 
}

getFilter(filterName, value) {
    return {
        "FilterName": filterName,
        "Value": value
    }
}

}

1


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/deployed-packages-details/deployed-details-packages.component.ts